export default "__VITE_ASSET__BkHsyjj5__"